import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ProfileSection from './components/ProfileSection';
import ConceptSection from '../about/components/ConceptSection';
import MessageSection from './components/MessageSection';
import CTASection from '../home/components/CTASection';
import { updatePageSEO } from '../../utils/seo';

const DoctorPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);

    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
    
    updatePageSEO({
      title: '院長紹介 | おかやま整形外科 - 岡山市北区の整形外科クリニック',
      description: '岡山花子院長のご紹介。整形外科専門医として20年以上の経験を持ち、スポーツ障害、関節痛、腰痛治療を専門としています。患者様一人ひとりに寄り添った丁寧な診療を心がけています。',
      keywords: '院長紹介, 岡山花子, 整形外科専門医, おかやま整形外科, 医師紹介',
      canonical: `${siteUrl}/doctor`,
      structuredData: {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: '院長紹介',
        description: 'おかやま整形外科の院長、岡山花子のご紹介',
        url: `${siteUrl}/doctor`,
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            {
              '@type': 'ListItem',
              position: 1,
              name: 'ホーム',
              item: `${siteUrl}/`
            },
            {
              '@type': 'ListItem',
              position: 2,
              name: '院長紹介',
              item: `${siteUrl}/doctor`
            }
          ]
        },
        mainEntity: {
          '@type': 'Person',
          name: '岡山花子',
          jobTitle: '院長',
          worksFor: {
            '@type': 'MedicalOrganization',
            name: 'おかやま整形外科'
          },
          description: '整形外科専門医として20年以上の経験を持ち、スポーツ障害、関節痛、腰痛治療を専門としています。'
        }
      }
    });
  }, []);

  return (
    <div className="min-h-screen bg-white font-['Noto_Sans_JP']">
      <Header />
      <main>
        <HeroSection />
        <ProfileSection />
        <ConceptSection />
        <MessageSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default DoctorPage;
